import React from 'react'
import { useEffect } from 'react';
import { OpinionService } from 'utils/OpinionService';
import SecondOpinionSideBar from '../../SecondOpinionSideBar';
import { useState } from 'react';
import OpinionInfo from './OpinionInfo';
import { FAILED_TO_FETCH_DATA } from 'utils/Constants';
import LoadMoreButton from 'common/LoadMoreButton/LoadMoreButton';
import CommonLoader from 'common/CommonLoader';
import { Col } from 'reactstrap';

export default function ReceivedSecondOpinionLists(props) {
    const [opinions, setOpinions] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [filters, setFilters] = useState([]);

    function createQuery(filters) {
        // setIsLoading(true);
        let sq = "";
        filters.map((e) => {
            if (sq === "") {
                sq = "st=='" + e + "'";
            } else {
                sq += ",st=='" + e + "'";
            }
        })
        return sq;
    }

    const getOpinions = (pageNo, filters) => {
        let fsq = createQuery(filters);
        OpinionService.getOpinions(fsq, pageNo)
            .then((response) => {
                const { data, status } = response;
                if (data?.currentPage < (data?.totalPages - 1))
                    setHasMore(true);
                else
                    setHasMore(false);
                setIsLoadingMore(false);
                if (status === 200) {
                    if (pageNo === 0)
                        setOpinions(data.contents);
                    else
                        setOpinions([...opinions, ...data.contents]);

                    setCurrentPage(data?.currentPage);
                    console.log(data.contents);
                    setIsLoading(false);
                } else {
                    setIsLoadingMore(false);
                    console.log(FAILED_TO_FETCH_DATA);
                    setIsLoading(false);
                }
            })
    }

    useEffect(() => {
        getOpinions(0, filters);
    }, [filters])

    const fetchMoreData = () => {
        setIsLoadingMore(true);
        getOpinions(currentPage + 1, filters);
    };

    if (isLoading) {
        return (
            <div className="text-center mt-3">
                <CommonLoader style={{ width: "2rem", height: "2rem" }} />
            </div>
        )
    }

    return (
        <>
            <div className="nexogic-second-option container-fluid">
                <div className="row">
                    {/* <div className="col-lg-4 col-xl-3 nexogic-second-option-aside">
                        <div className="nexogic-sidebar-stiky">
                            <SecondOpinionSideBar setFilters={setFilters} />
                        </div>
                    </div> */}
                    <Col lg={12} xl={12} sm={12} className="nexogic-second-option-left">
                        <h1 className='nex-section-title'>Received Second Opinion Requests </h1>
                        {(opinions && opinions.length > 0) && opinions.map((e) => (
                            <OpinionInfo opinion={e} />
                        ))
                        }
                        {hasMore &&
                            <div className="text-center mt-3">
                                {isLoadingMore
                                    ?
                                    <CommonLoader style={{ width: "2rem", height: "2rem" }} />
                                    :
                                    <LoadMoreButton loadMore={fetchMoreData} />
                                }
                            </div>
                        }
                    </Col>
                </div>

            </div >
        </>
    )
}

